import { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../../assets/restore_mini_logo.png';

const LogoWrapper = styled(Link)`
  display: block;
  height: 48px;
  width: 48px;
  margin: 0 32px 0 0;
`;

export interface ILogo {
  to: string;
  altText: string;
}

const Logo: FC<ILogo> = ({ to, altText }) => {
  return (
    <LogoWrapper to={to}>
      <img src={logo} alt={altText} />
    </LogoWrapper>
  );
};

export default Logo;
